export default "__VITE_ASSET__CDYs4Ad3__"